import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import data from "@/utils/app_data";
import Layout from "../layout/index.vue";
import home from "../pages/home/index.vue";
import waiver from "../pages/policy/waiver.vue";
import playgroundRules from "../pages/policy/playgroundRules.vue";
import partyBook from "../pages/party/index.vue";
import privacy from "../pages/policy/privacy.vue";
import terms from "../pages/policy/terms.vue";
import pricing from "../pages/pricing/index.vue";
import pass from "../pages/pricing/pass.vue";
import unlimited from "../pages/pricing/unlimited.vue";
import party from "../pages/pricing/party.vue";
import gallery from "../pages/gallery/index.vue";
import career from "../pages/career/index.vue";
import success from "../pages/pay/success.vue";
import error from "../pages/pay/error.vue";
import noPage from "../pages/404.vue";
Vue.use(Router);

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        component: home,
        meta: {
          title: "首页"
        }
      },
      {
        path: "/policy/waiver",
        name: "waiver",
        component: waiver
      },
      {
        path: "/policy/playground-rules",
        name: "playground-rules",
        component: playgroundRules
      },
      {
        path: "/policy/privacy",
        name: "privacy",
        component: privacy
      },
      {
        path: "/policy/terms",
        name: "terms",
        component: terms
      },
      // {
      //   path: "/party-book",
      //   name: "party-book",
      //   component: partyBook
      // },
      {
        path: "/pricing/pass",
        name: "pass",
        component: pass
      },
      {
        path: "/pricing",
        name: "pricing",
        component: pricing
      },
      {
        path: "/pricing/unlimited",
        name: "unlimited",
        component: unlimited
      },
      {
        path: "/pricing/party",
        name: "party",
        component: party
      },
      {
        path: "/gallery",
        name: "gallery",
        component: gallery
      },
      {
        path: "/career",
        name: "career",
        component: career
      },
      {
        path: "/success",
        name: "success",
        component: success
      },
      {
        path: "/error",
        name: "error",
        component: error
      }
    ]
  },
  {
    path: "*",
    component: noPage,
    meta: {
      title: "404"
    }
  }
];
let router = new Router({
  mode: "history",
  base: "",
  routes
});

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  next();
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js